import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';

export const CutOffAlert = (props) => {
 
  const classes = useStyles();

  const handleOkBtnClick = async () => {
    props.handleCutOffBtn()
  }

  return (
    <Dialog  PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleCutOffBtn} open={true} className={classes.dialogClass}>
       <IconButton onClick={props.handleCutOffBtn} className={classes.closeIcon}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.root}>
          <Box className={classes.cardBody}>
            <Typography className={classes.statusTitle}>Cutoff Time Reached</Typography>
          </Box>
        
          <Box className={classes.cardBodyContainer}>
            <Typography className={classes.records}>One-time payment scheduling after <b>9 PM Eastern Time</b> isn’t allowed for the same day. Pick tomorrow or a later date.</Typography>
          </Box>

          <Box className={classes.cardFooter}>
            <Button
              variant='contained'
              color='primary'
              className={classes.btn}
              onClick={() => handleOkBtnClick()}
              >OK</Button>
          </Box>
        </Box> 
    </Dialog>
  )
}
